<template>
    <div class="conversation" >
        <send-message :messages="messages"></send-message>
    </div>
</template>

<script>
import SendMessage from '../SendMessage.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    name: 'Conversation',
    props: {
        message: String
    },
    components: {
        SendMessage
    },
    data() {
        return {
        }
    },
    computed: {
        ...mapState(['messages']),
        ...mapGetters(['messages', 'shareCartAvailable']),
    },
    methods: {
        notifyPollShown() {
            this.$emit('poll-shown');
        }
    },
    created() {
        this.$on('poll-shown', this.handlePollShown);
    }
}
</script>